import getExpoCopyText from "lib/getExpoCopyText"
import useCurrent from "lib/use-current"

export const useExpoCopyText = () => {
  const current = useCurrent()
  if (!current) return null
  return getExpoCopyText(current)
}
